import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { changeProjectSelector } from 'selectors'
import { deviceCountSelector } from 'selectors/components'
import getDocument from 'helpers/databases/getDocument'
import updateDocument from 'helpers/databases/updateDocument'
import { expandProjectAction } from 'actions/projectActions'
import { updateProjectAction } from 'actions/projectActions'
import { CHANGE_PROJECT } from 'actions/projectActionTypes'
import clearMapComponents from 'helpers/map/clearMapComponents'
import { notifyHoneybadgerAction, waitForMapIdleAction } from 'actions/applicationActions'
import { clearCamerasAction } from 'actions/cameraActions'

export function * changeProject(action) {
  try {
    const { map, cameras, database, permalink } = yield select(changeProjectSelector)
    const deviceCount = yield select(deviceCountSelector)

    const project = yield call(getDocument, database, action.id)

    if (permalink) {
      yield call(updateDocument, database, { _id: action.id, updatedAt: Date.now() })
      return window.location.assign(window.location.origin)
    }

    yield put(updateProjectAction({ deviceCount }))

    yield call(clearMapComponents, { map, cameras })

    // https://github.com/ipvideomarketinfo/calculator-v3/issues/555
    // clear cameras to here to ensure that camera components unmount
    yield put(clearCamerasAction())

    yield put(waitForMapIdleAction(map.ref))

    yield put(expandProjectAction(project))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchChangeProject() {
  yield * takeEvery(CHANGE_PROJECT, changeProject)
}



// WEBPACK FOOTER //
// ./src/sagas/changeProjectSaga.js